module.exports = __webpack_public_path__ + "static/img/success-qrcode.f90dec3e.png";